import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { bulkActionEffectFactory } from '@core/async-job-data';
import { AsyncJobType } from '@core/async-job-types';

import { LocationsBulkActionsHttpClient } from './bulk-actions-http-client';
import { LocationsBulkActions } from './bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class LocationsBulkEffects {
  private readonly actions$ = inject(Actions);
  private readonly bulkActionsHttpClient = inject(LocationsBulkActionsHttpClient);

  public merge$ = bulkActionEffectFactory(
    this.actions$,
    LocationsBulkActions,
    'merge',
    AsyncJobType.BulkLocationsMerge,
    params => this.bulkActionsHttpClient.merge(params),
  );
}
